import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";

interface student{
    name:string,
    tel:string,
    id:string,
    pw:string,
    email:string,
    address:string,
    address_detail:string,
    school:string,
    join_date:string,
    parent_name:string,
    parent_tel:string,
    birth:string,
    shuttle:boolean,
    fee:string,
    level:number,
    status: 'active' | 'suspended' | 'graduated'
}

const useStudentInfo = (student_id:string) => {
    const {readFirestoreOneDoc} = useFirestore();
    const [student, setStudent] = useState<student>({
        name:"",
        tel:"",
        id:"",
        pw:"",
        email:"",
        address:"",
        address_detail:"",
        school:"",
        join_date:"",
        parent_name:"",
        parent_tel:"",
        birth:"",
        fee:"",
        level:1,
        shuttle:false,
        status: 'active'
    });

    useEffect(() => {
        if(student_id){
            getData();
        }
        // eslint-disable-next-line
    }, [student_id])

    const getData = async() => {
        const data = await readFirestoreOneDoc("User/Auth/Student", student_id).then(res => {
            if(res.exists()){
                return res.data();
            }else{
                return null;
            }
        })
        if(data){
            setStudent({
                name:data.name,
                tel:data.tel,
                id:data.id,
                pw:data.pw,
                email:data.email || "",
                address:data.address || "",
                address_detail:data.address_detail || "",
                school:data.school || "",
                join_date:data.join_date || "",
                parent_name:data.parent_name || "",
                parent_tel:data.parent_tel || "",
                birth:data.birth || "",
                level:data.level,
                shuttle:data.shuttle,
                fee:data.fee,
                status: data.status || 'active'
            })
        }
    }

    const onRefreshClick = () => {
       getData();
    }

    return {student, onRefreshClick};
}

export default useStudentInfo;